import { Form, Input, Tooltip } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../../components/DraggableModal";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { aliasText } from "../../../../../utils";

enum FormField {
    alias,
    nameKy,
    nameRu
}

interface IProps {
    show: boolean;
    ownershipType: EntDirectoryInfoName;  // Updated prop name
    onHide: () => void;
    onSubmit: (pos: EntDirectoryInfoName) => Promise<boolean>;
}

export const AddOwnershipTypesModal = (props: IProps) => {  // Updated component name
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.nameKy, value: props.ownershipType.nameKy },  // Updated prop name
            { name: FormField.nameRu, value: props.ownershipType.nameRu },  // Updated prop name
            { name: FormField.alias, value: props.ownershipType.alias },  // Updated prop name
        ]);
    }

    const setEntityFromFields = (): EntDirectoryInfoName => {
        let res = _.cloneDeep(props.ownershipType);  // Updated prop name
        res.id = props.ownershipType.id;  // Updated prop name
        res.nameKy = form.getFieldValue(FormField.nameKy);
        res.nameRu = form.getFieldValue(FormField.nameRu);
        res.alias = form.getFieldValue(FormField.alias);
        return res;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
           
            const result = await props.onSubmit(data);
           
            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.ownershipType.id === 0 ? t('mechanisation.form_of_ownership.add_form_of_ownership') : t('mechanisation.form_of_ownership.edit_form_of_ownership')}  // Updated prop name
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Tooltip title={aliasText} >
                        <Form.Item
                          label={t('general.alias')}
                          name={FormField.alias}
                          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                        >
                            <Input maxLength={255} showCount autoComplete="off" />
                        </Form.Item>
                    </Tooltip>
                    <Form.Item
                        label={ t('general.nameKy') }
                        name={FormField.nameKy}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={ t('general.nameRu') }
                        name={FormField.nameRu}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                </Form>
            </DraggableModal>
        </>
    );
}
